// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"fcc44929","319":"a37a51d3","530":"b27398d7","745":"ebb78001","931":"b27398d7"}[chunkId] + ".chunk.css";
};